import { Acao } from "./acao";
import { Localidade } from "./localidade";

export class Evento {

    public id:number;
    public acao: Acao;
    public local: Localidade;
    public status:string;
    public itinerante: boolean;
    public veiculo_obrigatorio: boolean;
    // ECOENEL-258: habilita cadastro de contrato em campo pelo Operador neste evento
    public cadastro_em_campo: boolean;

}


// WEBPACK FOOTER //
// ./src/domain/evento.ts